import React, { useEffect, useRef } from "react";
import postEvent, {
  createParkWebRedirectFosEvent,
} from "../commons/LanderEvent";
import { Settings } from "../config";
import { TargetedConfig } from "../commons/ConfigContext";
import { setAdBlockPlusStatus } from "../adblock/adBlockPlusStatus";

interface TargetedProps {
  targeted: TargetedConfig;
  queryConfig?: Record<string, any>;
}

export default function TargetedLander({
  targeted,
  queryConfig,
}: TargetedProps) {
  const eventFiredRef = useRef(false);

  useEffect(() => {
    if (eventFiredRef.current) return;
    eventFiredRef.current = true;

    let cancelled = false;

    // Wait for the ABP probe to settle before stamping the event, so an
    // unblocked shopper isn't misclassified as "acceptable" while the probe is
    // still mid-flight. setAdBlockPlusStatus() returns the shared detection
    // promise started at app init; awaiting it only delays this fire-and-forget
    // event, not the iframe redirect below.
    (async () => {
      await setAdBlockPlusStatus();
      // Don't fire into the void if the component unmounted while we waited.
      if (cancelled) return;
      const redirectEvent = createParkWebRedirectFosEvent(queryConfig);
      postEvent(Settings.EVENT_PUBLISH_API, redirectEvent);
    })();

    return () => {
      cancelled = true;
    };
  }, [queryConfig]);

  return (
    <iframe
      title="parked-content"
      width="100%"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        border: 0,
      }}
      src={ targeted.fosUrl }
    >
      Sorry your browser does not support inline frames.
    </iframe>
  );
}
